import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Card, Row, Col, Container } from "react-bootstrap";
import pro1 from "../images/pro1.jpeg";
import pro2 from "../images/pro2.jpeg";
import pro3 from "../images/pro3.jpeg";
import pro4 from "../images/pro4.jpeg";
import pro5 from "../images/pro5.jpeg";
import pro6 from "../images/pro6.jpeg";

const products = [
  { id: 1, title: "Bulb", description: "11 Watt", image: pro1 },
  { id: 3, title: "Bulb", description: "40 Watt", image: pro3 },
  { id: 4, title: "Bulb", description: "24 Watt", image: pro4 },
  { id: 5, title: "Bulb", description: "20 Watt", image: pro5 },
  { id: 6, title: "Bulb", description: "30 Watt", image: pro6 },
  { id: 2, title: "Downlight", description: "12 Watt", image: pro2 },
];

function NewsCards() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="news-wrapper">
      <h2 data-aos="fade-up">Our Products</h2>
      <Container className="mt-5">
        <Row className="justify-content-center">
          {products.map((product, index) => (
            <Col key={product.id} md={4} sm={6} className="mb-5" data-aos="fade-up" data-aos-delay={`${index * 100}`}>
              <Card className="product-card">
                <div className="image-container">
                  <Card.Img variant="top" src={product.image} className="product-image" />
                  <div className="overlay"></div>
                  <div className="details">
                    <h5>{product.title}</h5>
                    <p>{product.description}</p>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default NewsCards;
